import { render, staticRenderFns } from "./findings_drawer_item.vue?vue&type=template&id=6c8b4026"
import script from "./findings_drawer_item.vue?vue&type=script&lang=js"
export * from "./findings_drawer_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports